import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PwaUpdateComponent as PwaUpdateComponentCore } from '@df/module-pwa/update/pwa-update.component';
import { TranslationModule } from '@df/ui/translation/translation.module';

@Component({
    selector: 'pwa-update',
    templateUrl: './pwa-update.html',
    styleUrls: ['./pwa-update.scss'],
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaUpdateComponent extends PwaUpdateComponentCore {}
